/**
 * Gets the public S3 bucket configured by Laravel.
 *
 * The value is rendered in the main Blade template because this project
 * already defines S3_PUBLIC_BUCKET as a backend environment variable.
 *
 * @returns {string} Public S3 bucket without trailing slash.
 */
export function GetPublicS3Bucket() {
    const meta = document.querySelector('meta[name="s3PublicBucket"]');
    const bucket = meta ? meta.getAttribute("content") : "";

    return String(bucket || "").replace(/\/$/, "");
}

/**
 * Builds an absolute URL for an asset stored in the public S3 bucket.
 *
 * @param {string} path Asset path, with or without leading slash.
 * @returns {string} Absolute public asset URL.
 */
export function GetS3AssetUrl(path = "") {
    const bucket = GetPublicS3Bucket();
    const assetPath = String(path || "").replace(/^\//, "");

    if (!bucket || !assetPath) {
        return "";
    }

    return `${bucket}/${assetPath}`;
}

export default {
    GetPublicS3Bucket,
    GetS3AssetUrl,
};